import { ReactNode } from "react";
import { Box } from "@mui/material";
import { DotLegalDialog, DotLegalFullScreenSpinner } from "@dotlegal/dotlegal-ui-components";
import { EntityType } from "@common/Common.types";
import { useTranslation } from "@localization/useTranslation";
import EntityGraph from "./EntityGraph";
import EntityGraphHeaderBar from "./EntityGraphHeaderBar";
import { useEntityGraphStyles } from "./EntityGraph.styles";
import { useEntityGraphDialog } from "./EntityGraphDialog.hooks";
import { EntityGraphApiRisk, EntityGraphOverlay } from "./EntityGraph.types";

export interface EntityGraphDialogProps {
    rootType: EntityType;
    rootId: string;
    onClose: () => void;
    riskAreaId?: string;
    topContent?: ReactNode;
    overlayFactory?: (risk: EntityGraphApiRisk) => EntityGraphOverlay;
}

function EntityGraphDialog(props: EntityGraphDialogProps) {
    const { nodes, edges, rootKey, onRootChange, risk, isLoading, hasData } = useEntityGraphDialog(props);
    const styles = useEntityGraphStyles();
    const { translateString } = useTranslation();

    const overlay = risk && props.overlayFactory ? props.overlayFactory(risk) : undefined;

    return (
        <DotLegalDialog open size="fullscreen" fullHeight hideOkButton buttonOkText="" onOkClick={() => {}} onDialogClose={props.onClose} setCustomHeader>
            <Box sx={styles.dialogShell}>
                {hasData ? (
                    <EntityGraph
                        nodes={nodes}
                        edges={edges}
                        rootKey={rootKey}
                        onRootChange={onRootChange}
                        overlay={overlay}
                        toolbarContent={props.topContent}
                        title={translateString("entityGraphTitle")}
                        onClose={props.onClose}
                    />
                ) : (
                    <>
                        <EntityGraphHeaderBar title={translateString("entityGraphTitle")} onClose={props.onClose} />
                        {isLoading && (
                            <Box sx={{ flex: 1 }}>
                                <DotLegalFullScreenSpinner />
                            </Box>
                        )}
                    </>
                )}
            </Box>
        </DotLegalDialog>
    );
}

export default EntityGraphDialog;
